import { InjectionToken } from '@angular/core';
import { StableCache } from '@nk/caching-lib';
import {
  CompanyLocationEntity,
  CompanyLocationTypeEntity,
  GeoCountryEntity,
  GeoPostalCodeEntity,
  WithUuid,
} from '@nk/data-entities-lib';
import { Observable } from 'rxjs';

export interface GeoApiService {
  geoCountryListCache: StableCache<GeoApiService, () => Observable<WithUuid<GeoCountryEntity>[]>>;
  geoPostalCodeListCache: StableCache<
    GeoApiService,
    (geoCountryIdentifiers?: string, geoPostalCodeUuids?: string[]) => Observable<GeoPostalCodeEntity[]>
  >;
  companyLocationTypeCache: StableCache<GeoApiService, () => Observable<WithUuid<CompanyLocationTypeEntity>[]>>;
  companyLocationCache: StableCache<GeoApiService, (companyUuid: string) => Observable<CompanyLocationEntity[]>>;
}

export const GEO_API_SERVICE_TOKEN = new InjectionToken<GeoApiService>('GeoApiService');
